import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";

export const WaveMark = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="nw-chrome" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F8FAFC" />
        <stop offset=".5" stopColor="#94A3B8" />
        <stop offset="1" stopColor="#E2E8F0" />
      </linearGradient>
    </defs>
    <rect x="1" y="1" width="30" height="30" rx="8" fill="#0A0B10" stroke="url(#nw-chrome)" strokeWidth="1.5" />
    <path d="M5 19c3-6 6-6 9 0s6 6 9 0 3-5 4-5" fill="none" stroke="#FF1E27" strokeWidth="2.6" strokeLinecap="round" />
    <path d="M5 13c3-4 6-4 9 0s6 4 9 0" fill="none" stroke="url(#nw-chrome)" strokeWidth="1.6" strokeLinecap="round" opacity=".8" />
  </svg>
);

export const Logo = () => (
  <Link to="/" data-testid={NAV.logo} className="flex items-center gap-2.5 group">
    <WaveMark className="h-8 w-8 transition-transform duration-300 group-hover:rotate-[-6deg]" />
    <span className="font-display text-lg font-extrabold tracking-[0.18em] chrome-text">
      NEW<span className="text-nw-red ml-1">WAVE</span>
    </span>
  </Link>
);
